import React from 'react';
import { Component, PuzzleButton } from "puzzle";
import { PROPS, STATE } from "./Types";
import { GridCellProps } from "@progress/kendo-react-grid";

class ClaimDialogAbstract<GENERIC_PROPS, GENERIC_STATE> extends Component<GENERIC_PROPS & PROPS, GENERIC_STATE & STATE> {

  /**
   * Date render
   * @param dateType
   * @param cellProps
   */
  dateRender = (dateType: string, cellProps: GridCellProps): JSX.Element => {
    const { dataItem } = cellProps;
    const dateData = dataItem[dateType];
    return <span className={dateType === 'dueDate' ? 'pd-claim-due-date-cell tp-text-semibold': ''}>
      {dateData ? this.translateByNamespace('date.dateWithTime', { date: new Date(dateData) }) : ''}
    </span>;
  };

  /**
   * Determinants should word count be clickable
   */
  isWordCountClickable = () => true;

  /**
   * Opens word count dialog
   */
  openWordCount = () => {
    this.dispatch('openWordCount', '', {
      downloadWordCountParams: {
        downloadTmStatistics: true
      },
      submission: this.props.submissionData,
    });
  };


  /**
   * Status cell render
   */
  statusCellRender = (cellProps: GridCellProps): JSX.Element => {
    const { dataItem } = cellProps;
    return (
      <span className="tp-dialog-claim-phases-status-cell not-claimed">
        {this.translate(dataItem.status)}
      </span>
    )
  };

  /**
   * Word count render
   * @param cellProps
   */
  wordCountRender = (cellProps: GridCellProps): JSX.Element => {
    const { dataItem } = cellProps;
    const wordCount = dataItem.wordCount;
    return (
      <>
        {dataItem.wordCount !== null ? this.isWordCountClickable() ?
          <PuzzleButton
            aria-label={this.translate('SRL-openWordCount') + ' ' + this.translate('wordCount', { wordCount })}
            className={'tp-grid-button tp-text-underline'}
            themeColor={'primary'}
            fillMode={'link'}
            size={'small'}
            onClick={this.openWordCount}
          >
            {dataItem.wordCount}
          </PuzzleButton> : <span>{dataItem.wordCount}</span> : <span>
            {this.translate('nonParsableWordCount')}
          </span>
        }
      </>
    )
  };
}

export default ClaimDialogAbstract;
